export const selectQbClass = payload => ({
    type: 'SELECT_QB_CLASS',
    payload,
});

export const setAllQbClasses = payload => ({
    type: 'SET_ALL_QB_CLASSES',
    payload,
});

export const addQbClass = payload => ({
    type: 'ADD_QB_CLASS',
    payload,
});

export const updateQbClassSuccess = payload => ({
    type: 'UPDATE_QB_CLASS_SUCCESS',
    payload,
});

export const updateQbClassError = error => ({
    type: 'UPDATE_QB_CLASS_ERROR',
    error,
});

export const hideQbClass = qbClassId => ({
    type: 'DEACTIVATE_QB_CLASS',
    qbClassId,
});

export const unhideQbClass = qbClassId => ({
    type: 'ACTIVATE_QB_CLASS',
    qbClassId,
});

export const hideQbClassSuccess = qbClass => ({
    type: 'DEACTIVATE_QB_CLASS_SUCCESS',
    qbClass,
});

export const hideQbClassError = error => ({
    type: 'DEACTIVATE_QB_CLASS_ERROR',
    error,
});

export const unhideQbClassSuccess = qbClass => ({
    type: 'ACTIVATE_QB_CLASS_SUCCESS',
    qbClass,
});

export const unhideQbClassError = error => ({
    type: 'ACTIVATE_QB_CLASS_ERROR',
    error,
});
